module.exports = __webpack_public_path__ + "static/media/gnv.d570d7a5.svg";